import classNames from 'classnames';

import { postCardSubtitle } from '../Post.css';

interface Props {
  subtitle: string;
  className?: string;
}

const Subtitle = ({ subtitle, className }: Props) => {
  return <p className={classNames(postCardSubtitle, className)}>{subtitle}</p>;
};

export default Subtitle;
